export default __webpack_public_path__ + "static/media/auth.4fc94eab.svg";